import axios from '../../config';
import { isEmpty } from 'lodash';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';

const imageUrl = window.__RUNTIME_CONFIG__.REACT_APP_UTILITY_IMAGE_ENDPOINT;

const Footer = () => {
	const { themeSettings, image, contact, bankName, appLink, socialLink, footerSideMenu } =
		useSelector((state: any) => state?.theme);
	const { metaDataSource } = useSelector((state: any) => state?.menu);

	const { footerMenuData } = useSelector((state: any) => state?.menu);

	return (
		<div>
			<footer>
				<div className="footer-wrapper">
					<div className="container">
						<div className="row footer__top">
							<div className="col-lg-4 col-md-3 col-sm-6">
								<div>
									{!isEmpty(image?.FooterLogo) && (
										<a aria-current="page" href="/" className="mb-4 d-block active" title="Home">
											<img
												src={imageUrl + image?.FooterLogo}
												alt={contact?.CopyRightText}
												className="img-fluid"
											/>
										</a>
									)}
									<div
										className={`footer__pageLinks ${
											metaDataSource !== 'nabil' ? 'underlined' : ''
										}`}>
										<div>
											<ul className="list-unstyled">
												{!isEmpty(contact?.CustomerCareEmail) && (
													<li>
														<img
															src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAQAAAD4iURRAAAAAmJLR0QA/4ePzL8AAADESURBVBjTY2BgmJIy9dbUv1P/I8H3U+f2CzAApZJQhBHwMFByWvzUP9gkp+z9z8iwinma/dSXGFIzZ7ICJafGTZGfKjv1NJLUjylJM7mm+fUrMExJm5I23ayPc+pCqNTj6WYzRSZHTUubpsQAJIBwqsc29il5U69MXTZdbIbq9CSwqBJQJ0R6Wuh0MQaG+RxT7KbBRJQYpqbCOWlTE5B50xUYpoYguKgQGAwzVLFLTXdnAIEZqlNDkI0DGh89w7KBhYEBAFVXtadhdJARAAAAAElFTkSuQmCC"
															className="img-fluid mr-2"
														/>
														<a href={`mailto:${contact?.CustomerCareEmail}`} className="ms-2">
															{contact?.CustomerCareEmail}
														</a>
													</li>
												)}
												{!isEmpty(contact?.CustomerCarePhone) && (
													<li>
														<img
															src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAQAAAD8fJRsAAAAAmJLR0QA/4ePzL8AAADMSURBVBjTY2BgmGI3Nb2BhQEIVrFNjZvm3S8JYjNMjZ76b+r/qRPAHIaZXFM1p8RO0wNJvAEK/wdKmjIwTGKfGjJNbyrPlNipEgxTb4Al/k7RBusQmR4MlNKc4cUwtQkssZ0BCqYITwsFGhjHMJN/6mOgxIdJojCp+RwMDA0cDGBX/QBK7VnFxoAOpkaCXXZoqiyQbTDFFUlqWu7Uv0Cpb9P2g+mFk9gRukKmfgM7AwJLkHRNN5t6BSr8b5oLil0zWacUACXfTU1mYAAAdmdn8y0xgOIAAAAASUVORK5CYII="
															className="img-fluid mr-2"
														/>
														<a href={`tel:+977${contact?.CustomerCarePhone}`} className="ms-2">
															+977{contact?.CustomerCarePhone}
														</a>
													</li>
												)}
												{!isEmpty(contact?.BankSwiftCode) && (
													<li>
														SWIFT: <span className="ms-2">{contact?.BankSwiftCode}</span>
													</li>
												)}
											</ul>
										</div>
									</div>
									{!isEmpty(image?.FooterQRImage) && (
										<div className="footer__pageLinks underlined mb-5">
											<img
												src={`${imageUrl + image?.FooterQRImage}`}
												className="img-fluid"
												width="80px"
											/>
										</div>
									)}

									<div className="footer__pageLinks underlined">
										<div>
											<h5>Follow us</h5>
											<ul className="list-unstyled d-flex social-link-lists">
												{!isEmpty(socialLink?.FacebookUrl) && (
													<li>
														<a
															href={socialLink?.FacebookUrl}
															className="facebook-icon"
															target="_blank"
															rel="noreferrer">
															<svg
																stroke="currentColor"
																fill="currentColor"
																strokeWidth={0}
																viewBox="0 0 24 24"
																height="1em"
																width="1em"
																xmlns="http://www.w3.org/2000/svg">
																<g>
																	<path fill="none" d="M0 0h24v24H0z" />
																	<path d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4v-8.5z" />
																</g>
															</svg>
														</a>
													</li>
												)}
												{!isEmpty(socialLink?.TwitterUrl) && (
													<li>
														<a
															href={socialLink?.TwitterUrl}
															className="twitter-icon"
															target="_blank"
															rel="noreferrer">
															<svg
																stroke="currentColor"
																fill="currentColor"
																strokeWidth={0}
																viewBox="0 0 24 24"
																height="1em"
																width="1em"
																xmlns="http://www.w3.org/2000/svg">
																<g>
																	<path fill="none" d="M0 0h24v24H0z" />
																	<path d="M22.162 5.656a8.384 8.384 0 0 1-2.402.658A4.196 4.196 0 0 0 21.6 4c-.82.488-1.719.83-2.656 1.015a4.182 4.182 0 0 0-7.126 3.814 11.874 11.874 0 0 1-8.62-4.37 4.168 4.168 0 0 0-.566 2.103c0 1.45.738 2.731 1.86 3.481a4.168 4.168 0 0 1-1.894-.523v.052a4.185 4.185 0 0 0 3.355 4.101 4.21 4.21 0 0 1-1.89.072A4.185 4.185 0 0 0 7.97 16.65a8.394 8.394 0 0 1-6.191 1.732 11.83 11.83 0 0 0 6.41 1.88c7.693 0 11.9-6.373 11.9-11.9 0-.18-.005-.362-.013-.54a8.496 8.496 0 0 0 2.087-2.165z" />
																</g>
															</svg>
														</a>
													</li>
												)}
												{!isEmpty(socialLink?.LinkedInUrl) && (
													<li>
														<a
															href={socialLink?.LinkedInUrl}
															target="_blank"
															className="linkedin-icon"
															rel="noreferrer">
															<svg
																stroke="currentColor"
																fill="currentColor"
																strokeWidth={0}
																viewBox="0 0 24 24"
																height="1em"
																width="1em"
																xmlns="http://www.w3.org/2000/svg">
																<g>
																	<path fill="none" d="M0 0h24v24H0z" />
																	<path
																		fillRule="nonzero"
																		d="M6.94 5a2 2 0 1 1-4-.002 2 2 0 0 1 4 .002zM7 8.48H3V21h4V8.48zm6.32 0H9.34V21h3.94v-6.57c0-3.66 4.77-4 4.77 0V21H22v-7.93c0-6.17-7.06-5.94-8.72-2.91l.04-1.68z"
																	/>
																</g>
															</svg>
														</a>
													</li>
												)}
												{!isEmpty(socialLink?.InstagramUrl) && (
													<li>
														<a
															href={socialLink?.InstagramUrl}
															target="_blank"
															className="instagram-icon"
															rel="noreferrer">
															<svg
																stroke="currentColor"
																fill="currentColor"
																strokeWidth={0}
																viewBox="0 0 24 24"
																height="1em"
																width="1em"
																xmlns="http://www.w3.org/2000/svg">
																<g>
																	<path fill="none" d="M0 0h24v24H0z"></path>
																	<path
																		fillRule="nonzero"
																		d="M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0-2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm6.5-.25a1.25 1.25 0 0 1-2.5 0 1.25 1.25 0 0 1 2.5 0zM12 4c-2.474 0-2.878.007-4.029.058-.784.037-1.31.142-1.798.332-.434.168-.747.369-1.08.703a2.89 2.89 0 0 0-.704 1.08c-.19.49-.295 1.015-.331 1.798C4.006 9.075 4 9.461 4 12c0 2.474.007 2.878.058 4.029.037.783.142 1.31.331 1.797.17.435.37.748.702 1.08.337.336.65.537 1.08.703.494.191 1.02.297 1.8.333C9.075 19.994 9.461 20 12 20c2.474 0 2.878-.007 4.029-.058.782-.037 1.309-.142 1.797-.331.433-.169.748-.37 1.08-.702.337-.337.538-.65.704-1.08.19-.493.296-1.02.332-1.8.052-1.104.058-1.49.058-4.029 0-2.474-.007-2.878-.058-4.029-.037-.782-.142-1.31-.332-1.798a2.911 2.911 0 0 0-.703-1.08 2.884 2.884 0 0 0-1.08-.704c-.49-.19-1.016-.295-1.798-.331C14.925 4.006 14.539 4 12 4zm0-2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153a4.908 4.908 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 0 1-1.153 1.772 4.915 4.915 0 0 1-1.772 1.153c-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 0 1-1.772-1.153 4.904 4.904 0 0 1-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 0 1 1.153-1.772A4.897 4.897 0 0 1 5.45 2.525c.638-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2z"></path>
																</g>
															</svg>
														</a>
													</li>
												)}
												{!isEmpty(socialLink?.ViberUrl) && (
													<li>
														<a href={socialLink?.ViberUrl} className="viber-icon">
															<svg
																stroke="currentColor"
																fill="currentColor"
																strokeWidth={0}
																role="img"
																viewBox="0 0 24 24"
																height="1em"
																width="1em"
																xmlns="http://www.w3.org/2000/svg">
																<title></title>
																<path d="M11.398.002C9.473.028 5.331.344 3.014 2.467 1.294 4.177.693 6.698.623 9.82c-.06 3.11-.13 8.95 5.5 10.541v2.42s-.038.97.602 1.17c.79.25 1.24-.499 1.99-1.299l1.4-1.58c3.85.32 6.8-.419 7.14-.529.78-.25 5.181-.811 5.901-6.652.74-6.031-.36-9.831-2.34-11.551l-.01-.002c-.6-.55-3-2.3-8.37-2.32 0 0-.396-.025-1.038-.016zm.067 1.697c.545-.003.88.02.88.02 4.54.01 6.711 1.38 7.221 1.84 1.67 1.429 2.528 4.856 1.9 9.892-.6 4.88-4.17 5.19-4.83 5.4-.28.09-2.88.73-6.152.52 0 0-2.439 2.941-3.199 3.701-.12.13-.26.17-.35.15-.13-.03-.17-.19-.16-.41l.02-4.019c-4.771-1.32-4.491-6.302-4.441-8.902.06-2.6.55-4.732 2-6.172 1.957-1.77 5.475-2.01 7.11-2.02zm.36 2.6a.299.299 0 0 0-.3.299.3.3 0 0 0 .3.3 5.631 5.631 0 0 1 4.03 1.59c1.09 1.06 1.621 2.48 1.641 4.34a.3.3 0 0 0 .3.3v-.009a.3.3 0 0 0 .3-.3 6.451 6.451 0 0 0-1.81-4.76c-1.19-1.16-2.692-1.76-4.462-1.76zm-3.954.69a.955.955 0 0 0-.615.12h-.012c-.41.24-.788.54-1.148.94-.27.32-.421.639-.461.949a1.24 1.24 0 0 0 .05.541l.02.01a13.722 13.722 0 0 0 1.2 2.6 15.383 15.383 0 0 0 2.32 3.171l.03.04.04.03.03.03.03.03a15.603 15.603 0 0 0 3.18 2.33c1.32.72 2.122 1.06 2.602 1.2v.01c.14.04.268.06.398.06a1.84 1.84 0 0 0 1.102-.472c.39-.35.7-.738.93-1.148v-.01c.23-.43.15-.841-.18-1.121a13.632 13.632 0 0 0-2.15-1.54c-.51-.28-1.03-.11-1.24.17l-.45.569c-.23.28-.65.24-.65.24l-.012.01c-3.12-.8-3.95-3.959-3.95-3.959s-.04-.43.25-.65l.56-.45c.27-.22.46-.74.17-1.25a13.522 13.522 0 0 0-1.54-2.15.843.843 0 0 0-.504-.3zm4.473.89a.3.3 0 0 0 .002.6 3.78 3.78 0 0 1 2.65 1.15 3.5 3.5 0 0 1 .9 2.57.3.3 0 0 0 .3.299l.01.012a.3.3 0 0 0 .3-.301c.03-1.19-.34-2.19-1.07-2.99-.73-.8-1.75-1.25-3.05-1.34a.3.3 0 0 0-.042 0zm.49 1.619a.305.305 0 0 0-.018.611c.99.05 1.47.55 1.53 1.58a.3.3 0 0 0 .3.29h.01a.3.3 0 0 0 .29-.32c-.07-1.34-.8-2.091-2.1-2.161a.305.305 0 0 0-.012 0z"></path>
															</svg>
														</a>
													</li>
												)}
												{!isEmpty(socialLink?.YoutubeUrl) && (
													<li>
														<a
															href={socialLink?.YoutubeUrl}
															target="_blank"
															className="youtube-icon"
															rel="noreferrer">
															<svg
																stroke="currentColor"
																fill="currentColor"
																strokeWidth={0}
																viewBox="0 0 24 24"
																height="1em"
																width="1em"
																xmlns="http://www.w3.org/2000/svg">
																<g>
																	<path fill="none" d="M0 0h24v24H0z"></path>
																	<path d="M21.543 6.498C22 8.28 22 12 22 12s0 3.72-.457 5.502c-.254.985-.997 1.76-1.938 2.022C17.896 20 12 20 12 20s-5.893 0-7.605-.476c-.945-.266-1.687-1.04-1.938-2.022C2 15.72 2 12 2 12s0-3.72.457-5.502c.254-.985.997-1.76 1.938-2.022C6.107 4 12 4 12 4s5.896 0 7.605.476c.945.266 1.687 1.04 1.938 2.022zM10 15.5l6-3.5-6-3.5v7z"></path>
																</g>
															</svg>
														</a>
													</li>
												)}
												{!isEmpty(socialLink?.PinterestUrl) && (
													<li>
														<a
															href={socialLink?.PinterestUrl}
															target="_blank"
															className="pinterest-icon"
															rel="noreferrer">
															<svg
																stroke="currentColor"
																fill="currentColor"
																strokeWidth={0}
																viewBox="0 0 24 24"
																height="1em"
																width="1em"
																xmlns="http://www.w3.org/2000/svg">
																<g>
																	<path fill="none" d="M0 0h24v24H0z"></path>
																	<path d="M13.37 2.094A10.003 10.003 0 0 0 8.002 21.17a7.757 7.757 0 0 1 .163-2.293c.185-.839 1.296-5.463 1.296-5.463a3.739 3.739 0 0 1-.324-1.577c0-1.485.857-2.593 1.923-2.593a1.334 1.334 0 0 1 1.342 1.508c0 .9-.578 2.262-.88 3.54a1.544 1.544 0 0 0 1.575 1.923c1.898 0 3.17-2.431 3.17-5.301 0-2.2-1.457-3.848-4.143-3.848a4.746 4.746 0 0 0-4.93 4.794 2.96 2.96 0 0 0 .648 1.97.48.48 0 0 1 .162.554c-.046.184-.162.623-.208.784a.354.354 0 0 1-.51.254c-1.384-.554-2.036-2.077-2.036-3.816 0-2.847 2.384-6.255 7.154-6.255 3.796 0 6.32 2.777 6.32 5.747 0 3.909-2.177 6.848-5.394 6.848a2.861 2.861 0 0 1-2.454-1.246s-.578 2.316-.692 2.754a8.026 8.026 0 0 1-1.019 2.131c.923.28 1.882.42 2.846.416a9.988 9.988 0 0 0 9.996-10.003 10.002 10.002 0 0 0-8.635-9.903z"></path>
																</g>
															</svg>
														</a>
													</li>
												)}
												{!isEmpty(socialLink?.WhatsappUrl) && (
													<li>
														<a
															href={socialLink?.WhatsappUrl}
															target="_blank"
															className="pinterest-icon"
															rel="noreferrer">
															<svg
																xmlns="http://www.w3.org/2000/svg"
																viewBox="-2.73 0 1225.016 1225.016">
																<path
																	fill="#E0E0E0"
																	d="M1041.858 178.02C927.206 63.289 774.753.07 612.325 0 277.617 0 5.232 272.298 5.098 606.991c-.039 106.986 27.915 211.42 81.048 303.476L0 1225.016l321.898-84.406c88.689 48.368 188.547 73.855 290.166 73.896h.258.003c334.654 0 607.08-272.346 607.222-607.023.056-162.208-63.052-314.724-177.689-429.463zm-429.533 933.963h-.197c-90.578-.048-179.402-24.366-256.878-70.339l-18.438-10.93-191.021 50.083 51-186.176-12.013-19.087c-50.525-80.336-77.198-173.175-77.16-268.504.111-278.186 226.507-504.503 504.898-504.503 134.812.056 261.519 52.604 356.814 147.965 95.289 95.36 147.728 222.128 147.688 356.948-.118 278.195-226.522 504.543-504.693 504.543z"
																/>
																<linearGradient
																	id="a"
																	gradientUnits="userSpaceOnUse"
																	x1="609.77"
																	y1="1190.114"
																	x2="609.77"
																	y2="21.084">
																	<stop offset="0" stopColor="#20b038" />
																	<stop offset="1" stopColor="#60d66a" />
																</linearGradient>
																<path
																	fill="url(#a)"
																	d="M27.875 1190.114l82.211-300.18c-50.719-87.852-77.391-187.523-77.359-289.602.133-319.398 260.078-579.25 579.469-579.25 155.016.07 300.508 60.398 409.898 169.891 109.414 109.492 169.633 255.031 169.57 409.812-.133 319.406-260.094 579.281-579.445 579.281-.023 0 .016 0 0 0h-.258c-96.977-.031-192.266-24.375-276.898-70.5l-307.188 80.548z"
																/>
																<image
																	overflow="visible"
																	opacity=".08"
																	width="682"
																	height="639"
																	transform="translate(270.984 291.372)"
																/>
																<path
																	fillRule="evenodd"
																	clipRule="evenodd"
																	fill="#FFF"
																	d="M462.273 349.294c-11.234-24.977-23.062-25.477-33.75-25.914-8.742-.375-18.75-.352-28.742-.352-10 0-26.25 3.758-39.992 18.766-13.75 15.008-52.5 51.289-52.5 125.078 0 73.797 53.75 145.102 61.242 155.117 7.5 10 103.758 166.266 256.203 226.383 126.695 49.961 152.477 40.023 179.977 37.523s88.734-36.273 101.234-71.297c12.5-35.016 12.5-65.031 8.75-71.305-3.75-6.25-13.75-10-28.75-17.5s-88.734-43.789-102.484-48.789-23.75-7.5-33.75 7.516c-10 15-38.727 48.773-47.477 58.773-8.75 10.023-17.5 11.273-32.5 3.773-15-7.523-63.305-23.344-120.609-74.438-44.586-39.75-74.688-88.844-83.438-103.859-8.75-15-.938-23.125 6.586-30.602 6.734-6.719 15-17.508 22.5-26.266 7.484-8.758 9.984-15.008 14.984-25.008 5-10.016 2.5-18.773-1.25-26.273s-32.898-81.67-46.234-111.326z"
																/>
																<path
																	fill="#FFF"
																	d="M1036.898 176.091C923.562 62.677 772.859.185 612.297.114 281.43.114 12.172 269.286 12.039 600.137 12 705.896 39.633 809.13 92.156 900.13L7 1211.067l318.203-83.438c87.672 47.812 186.383 73.008 286.836 73.047h.255.003c330.812 0 600.109-269.219 600.25-600.055.055-160.343-62.328-311.108-175.649-424.53zm-424.601 923.242h-.195c-89.539-.047-177.344-24.086-253.93-69.531l-18.227-10.805-188.828 49.508 50.414-184.039-11.875-18.867c-49.945-79.414-76.312-171.188-76.273-265.422.109-274.992 223.906-498.711 499.102-498.711 133.266.055 258.516 52 352.719 146.266 94.195 94.266 146.031 219.578 145.992 352.852-.118 274.999-223.923 498.749-498.899 498.749z"
																/>
															</svg>
														</a>
													</li>
												)}
											</ul>
										</div>
									</div>
								</div>
							</div>
							{!isEmpty(metaDataSource)
								? {
										nabil: <NabilMenu />,
										system: <SystemMenu footerMenuData={footerMenuData} />,}[metaDataSource as string]
								: ''}
						</div>
						<div className="row footer__middle align-items-end">
							<div className="col-md-6">
								<div className="footer__pageLinks underlined d-flex mb-0">
									{!isEmpty(footerSideMenu?.SitemapUrl) && (
										<div className="footer__pageLink me-3">
											<a href={`${footerSideMenu?.SitemapUrl}`} title="Site Map">
												<h5 className="m-0">Site Map</h5>
											</a>
										</div>
									)}
									{!isEmpty(footerSideMenu?.PrivacyStatement) && (
										<div className="footer__pageLink">
											<a href={`${footerSideMenu?.PrivacyStatement}`} title="Privacy Statement">
												<h5 className="m-0">Privacy Statement</h5>
											</a>
										</div>
									)}
								</div>
							</div>
							<div className="col-md-6 text-center">
								<div
									className="footer__logo d-flex justify-content-center justify-content-md-end
        align-items-center
      ">
									{!isEmpty(appLink?.MobileAppQRImage) && (
										<img
											src={`${imageUrl + appLink?.MobileAppQRImage}`}
											className="mx-2 img-fluid"
											width="80px"
										/>
									)}
									{!isEmpty(appLink?.GooglePlaystoreUrl) && (
										<a target="_blank" href={appLink?.GooglePlaystoreUrl} rel="noreferrer">
											<img
												className="img-fluid"
												src="data:image/png;base64,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"
												alt="Nabil Bank App"
											/>
										</a>
									)}
									{!isEmpty(appLink?.AppstoreUrl) && (
										<a
											target="_blank"
											className="ms-3"
											href={appLink?.AppstoreUrl}
											rel="noreferrer">
											<img
												className="img-fluid"
												src="data:image/png;base64,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"
												alt="Nabil Bank App"
											/>
										</a>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="copyright-section">
					<div className="container">
						<div className="footer__bottom">
							<div className="row">
								<div className="col-md-12">
									<div
										className="
        d-flex
        flex-column flex-md-row
        justify-content-between
        align-items-center
        w-100
      ">
										<div className="footer__pageLink">
											Copyright © {moment().year()} {bankName?.CopyRightText || ''}. All Rights
											Reserved.
										</div>
										<div className="footer__pageLink d-flex">
											Crafted By&nbsp;
											<a
												href="http://amniltech.com/"
												target="_blank"
												rel="noreferrer"
												className={`${
													metaDataSource === 'nabil' ? 'text-success' : 'crafted-by underlined'
												}`}>
												AMNIL Technologies Pvt.Ltd
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</footer>
		</div>
	);
};

export default React.memo(Footer);

const NabilMenu = () => {
	const [footerData, setFooterData] = React.useState<any>([]);
	const [footerImage, setFooterImage] = React.useState<any>([]);
	const [footerContact, setFooterContact] = React.useState<any>([]);
	const { metaDataSource } = useSelector((state: any) => state?.menu);
	const username = window.__RUNTIME_CONFIG__.MENU_TYPE_API_USERNAME;
	const BaseUrl = window.__RUNTIME_CONFIG__.REACT_APP_DIGIBANK_URL;

	let data = new FormData();
	data.append('username', username);
	data.append('type', 'buttom');

	const fetchFooterData = async () => {
		try {
			const res: any = await axios.post('/', data);
			setFooterData(res.data.data);
		} catch (err: any) {
			console.log(err);
		}
	};
	let data1 = new FormData();
	data1.append('username', username);
	const fetchFooterImage = async () => {
		try {
			const res = await axios({
				method: 'post',
				url: `${BaseUrl}/rest-api/utility/getSiteDetail`,
				data: data1,
				headers: { 'Content-Type': 'multipart/form-data' },
			});
			setFooterImage(res.data.data[0]);
		} catch (err: any) {
			console.log(err);
		}
	};
	let data2 = new FormData();
	data2.append('username', username);
	const fetchFooterContact = async () => {
		try {
			const res = await axios({
				method: 'post',
				url: `${BaseUrl}/rest-api/utility/getContactDetail`,
				data: data2,
				headers: { 'Content-Type': 'multipart/form-data' },
			});

			setFooterContact(res.data.data[0]);
		} catch (err: any) {
			console.log(err);
		}
	};
	React.useEffect(() => {
		fetchFooterData();
		fetchFooterImage();
		fetchFooterContact();
	}, []);
	return (
		<>
			{footerData &&
				footerData.map((val: any, idx: number) => (
					<div className="col-lg-2 col-md-3 col-sm-6" key={idx}>
						<div className="footer__pageLinks">
							<h5>{val?.name}</h5>

							<ul className="list-unstyled" key={idx}>
								{val.children ? (
									val.children.map((sub: any, idx: number) => (
										<li key={idx}>
											<a target="_blank" rel="nofollow noreferrer" href={sub?.url}>
												{sub?.name}
											</a>
										</li>
									))
								) : (
									<span></span>
								)}
							</ul>
						</div>
					</div>
				))}
		</>
	);
};

const SystemMenu = ({ footerMenuData }: any) => {
	return (
		<div className="col-lg-8 col-md-9 col-sm-12">
			<div className="row">
				{footerMenuData.slice(0, 4)?.map((val: any, idx: number) => (
					<div className="col-lg-3 col-md-4 col-6" key={idx}>
						<div className="footer__pageLinks underlined">
							<h5>{val?.displayName}</h5>

							<ul className="list-unstyled">
								{!isEmpty(val.childMenuList) ? (
									val.childMenuList.map((sub: any, idx: number) => (
										<li key={idx}>
											<a target="_blank" rel="nofollow noreferrer" href={sub?.url}>
												{sub?.displayName}
											</a>
										</li>
									))
								) : (
									<span></span>
								)}
							</ul>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};
